import React from 'react';
import Facebook from '../Logos/facebook.png';
import LinkedIn from '../Logos/LinkedIn.png';

export default function Connect() {
    return (
        <div className='bg-cyan-800 p-12 w-full mx-auto rounded-md'>
            <h3 className='text-3xl text-white text-center font-bold'>GET CONNECTED</h3>
            <div className='mb-12 md:flex justify-evenly w-1/4 mx-auto mt-12'>
                <div className='mb-4'><a rel='noreferrer' href="https://www.linkedin.com/in/rmrokon/" target={"_blank"}><img width={"64px"} src={LinkedIn} alt="" /></a></div>

                <div><a rel='noreferrer' href="https://www.facebook.com/rmrokon"><img width={"64px"} src={Facebook} alt="" target={"_blank"} /></a></div>
            </div>
        </div>
    )
}
